var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 18V30C44 35 43 38.5 40.76 40.76L28 28L43.46 12.54C43.82 14.12 44 15.92 44 18Z",
    stroke: "#587E85",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.46 12.54L12.54 43.46C6.51998 42.08 4 37.92 4 30V18C4 8 8 4 18 4H30C37.92 4 42.08 6.52001 43.46 12.54Z",
    stroke: "#587E85",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7601 40.76C38.5001 43 35.0001 44 30.0001 44H18.0001C15.9201 44 14.12 43.82 12.54 43.46L28.0001 28L40.7601 40.76Z",
    stroke: "#587E85",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.48 15.9599C13.84 10.0999 22.6401 10.0999 24.0001 15.9599C24.7801 19.3999 22.62 22.3199 20.72 24.1199C19.34 25.4399 17.1601 25.4399 15.7601 24.1199C13.8601 22.3199 11.68 19.3999 12.48 15.9599Z",
    stroke: "#A9CF3D",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.1892 17.3999H18.2072",
    stroke: "#587E85",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMap);
export default __webpack_public_path__ + "static/media/new_map.475ad905070fc2442adb34a580fffa50.svg";
export { ForwardRef as ReactComponent };